import { request } from '../request';

export default {
  getConfigurations: () =>
    request({
      url: '/configurations',
      method: 'GET',
    }),
};
